import type { RSYSNum, USYSNum } from '../../../../schema/system/entry.js';
import { getSystemKeyFromNumber } from './getSystemKeyFromNumber.js';
import { systems } from './systemsData.js';

type SystemNumber = RSYSNum | USYSNum;

type System = (typeof systems)[keyof typeof systems];

/**
 * Returns the system object from the given system number.
 *
 * @param systemNum Numeric representation of the system
 * @returns System object definition
 */
export function getSystemFromNumber(systemNum: SystemNumber): System {
  const systemLabel = getSystemKeyFromNumber(systemNum);
  return systems[systemLabel];
}
